import { observer } from 'mobx-react';
import { sortDirection, valueFor } from '../../../../../ListFilter';
import { LicenseFamily } from '../../../../../Organization/Types';
import ParticipantsStore from '../../../../../ParticipantsStore';
import SortableColumn from '../../../../SortableColumn';
import OrganizationColumnHead from '../../../Columns/Organization/OrganizationColumnHead';
import CheckboxControls from '../CheckboxControls';
import GroupCountHeader from './GroupCountHeader';
import LimaHeaders from './Lima/Headers';

interface Props {
  store: ParticipantsStore;
  licenseFamily: LicenseFamily;
}

const sortBy = (store: ParticipantsStore) => valueFor('sort_by', store.searchParameters);

function Head({ store, licenseFamily }: Props) {
  return (
    <thead className="bg-gray-50">
      <tr>
        <th className="w-24 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
          <CheckboxControls participantsStore={store} />
        </th>
        <SortableColumn
          columnName={'Full Name'}
          currentSortKey={sortBy(store)}
          sortDirection={sortDirection(store.searchParameters)}
          onSortClicked={() => store.sorting('name')}
          sortKey="name"
          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        />
        <SortableColumn
          columnName={'Email'}
          currentSortKey={sortBy(store)}
          sortDirection={sortDirection(store.searchParameters)}
          onSortClicked={() => store.sorting('email')}
          sortKey="email"
          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        />
        <OrganizationColumnHead store={store} />
        <GroupCountHeader />
        <SortableColumn
          columnName={'Login Count'}
          currentSortKey={sortBy(store)}
          sortDirection={sortDirection(store.searchParameters)}
          onSortClicked={() => store.sorting('sign_in_count')}
          sortKey="sign_in_count"
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
        />
        <SortableColumn
          columnName={'Last Login'}
          currentSortKey={sortBy(store)}
          sortDirection={sortDirection(store.searchParameters)}
          onSortClicked={() => store.sorting('last_sign_in_at')}
          sortKey="last_sign_in_at"
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 xl:table-cell"
        />
        <LimaHeaders licenseFamily={licenseFamily} />
        <th
          className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
          aria-label="menu"
          children=""
        />
      </tr>
    </thead>
  );
}

export default observer(Head);
